import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * SubdomainRedirect — detects known subdomains and navigates to the
 * corresponding page path.  Only redirects when the visitor lands on
 * the root path ("/").  Non-root paths (e.g. /contact on any subdomain)
 * render normally so every page stays reachable from every domain.
 *
 * Uses react-router navigate() with { replace: true } for an instant
 * SPA transition — no full-page reload, no flash.
 */

const SUBDOMAIN_ROUTES = {
  offer: '/sell-your-home',
  renovation: '/renovation',
};

const SubdomainRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');

    // Only consider hostnames with 3+ parts (e.g. offer.pacificcrestprop.com)
    if (parts.length >= 3) {
      const subdomain = parts[0];
      const targetPath = SUBDOMAIN_ROUTES[subdomain];

      // Redirect only from the root path
      if (targetPath && location.pathname === '/') {
        navigate(targetPath, { replace: true });
      }
    }
  }, [navigate, location.pathname]);

  return null;
};

export default SubdomainRedirect;
